import React, {Component} from 'react'
import Container from './components/Container'
import DocumentTitle from 'react-document-title'

const Thanks = () => {
  return (
    <DocumentTitle title='Raunch – It’s time for a better cam site'>
      <Container>
        <p className='mb0'>Great! Your sign up was successful and you will be hearing from us very soon.</p>
        <p>In the meantime, follow <a href='https://twitter.com/raunch_'>Raunch on Twitter</a> for updates every so often.</p>
      </Container>
    </DocumentTitle>
  )
}

export default Thanks



// WEBPACK FOOTER //
// ./thanks.js